export default class ConfiguratorPrintsValidator {

    static maximumMaterialSize = {
        w: 2050, h: 3050
    };
    static maximumCutModeLaserFrezSize = {
        w: 2030, h: 3030
    };
    static maximumChainPolishedSize = {
        w: 1990, h: 1990
    }
    static maximumWithElementsSize = {
        w: 2030, h: 3030
    }
    static maximumTextShapeSize = {
        w: 3030, h: 2020
    }
    static maximumOtherShapeSize = {
        w: 2030, h: 3030
    }

    static factory(mainShapeType) {
        switch (mainShapeType.name) {
            case 'Rect':
            case 'Other':
                return new ConfiguratorPrintsValidator();
        }
    }

    setActiveCutMode(activeCutMode) {
        this.activeCutMode = activeCutMode;
    }

    setData(data) {
        this.activeCutMode = data.activeCutMode;
        this.visibleElements = data.visibleElements;
        this.materialSettings = data.materialSettings.subType ? data.materialSettings.subType : data.materialSettings.type;
    }

    maxW() {
        let maxW = ConfiguratorPrintsValidator.maximumMaterialSize.w;
        if (this.materialSettings && this.materialSettings.max_width) {
            maxW = Math.min(maxW, this.materialSettings.max_width);
        }
        if (this.visibleElements && this.visibleElements > 0) {
            maxW = Math.min(maxW, ConfiguratorPrintsValidator.maximumWithElementsSize.w);
        }
        if (this.activeCutMode) {
            if (this.activeCutMode.type.name === 'laser' || this.activeCutMode.type.name === 'frez') {
                maxW = Math.min(maxW, ConfiguratorPrintsValidator.maximumCutModeLaserFrezSize.w);
            } else if (this.activeCutMode.type.name === 'chainPolished') {
                maxW = Math.min(maxW, ConfiguratorPrintsValidator.maximumChainPolishedSize.w);
            }
        }
        return maxW;
    }

    maxH() {
        let maxH = ConfiguratorPrintsValidator.maximumMaterialSize.h;
        if (this.materialSettings && this.materialSettings.max_height) {
            maxH = Math.min(maxH, this.materialSettings.max_height);
        }
        if (this.visibleElements && this.visibleElements > 0) {
            maxH = Math.min(maxH, ConfiguratorPrintsValidator.maximumWithElementsSize.h);
        }
        if (this.activeCutMode) {
            if (this.activeCutMode.type.name === 'laser' || this.activeCutMode.type.name === 'frez') {
                maxH = Math.min(maxH, ConfiguratorPrintsValidator.maximumCutModeLaserFrezSize.h);
            } else if (this.activeCutMode.type.name === 'chainPolished') {
                maxH = Math.min(maxH, ConfiguratorPrintsValidator.maximumChainPolishedSize.h);
            }
        }
        return maxH;
    }
}
